import { MenuIcon } from "@heroicons/react/outline";
import classnames from "classnames";
import CartIcon from "components/CartIcon";
import React from "react";

interface Props {
  preview: boolean;
  backgroundColor: string;
  textColor: string;
  openSideBar: () => void;
  subtitle: string;
  title: string;
}
const MenuNavbarContent: React.FC<Props> = ({
  preview = false,
  backgroundColor,
  textColor,
  openSideBar,
  subtitle,
  title,
}) => {
  return (
    <div>
      <div
        className={classnames("p-4 tracking-wider", {
          "md:w-[390px] md:mx-auto md:rounded-t-2xl md:border-t-4 md:border-black md:border-x-4": !preview,
        })}
        style={{
          backgroundColor: backgroundColor,
          color: textColor,
        }}
      >
        <div className="grid grid-cols-navBar gap-1 items-center">
          <button>
            <MenuIcon className="h-6 w-6" onClick={openSideBar} />
          </button>
          <h1 className="truncate-2-lines text-center font-medium xs:text-lg text-sm">
            {title?.trim()}
          </h1>
          <CartIcon preview={preview} />
        </div>
        {subtitle ? (
          <h2 className="text-center text-xs xs:text-sm truncate-2-lines w-full">
            {subtitle.trim()}
          </h2>
        ) : null}
      </div>
    </div>
  );
};

export default MenuNavbarContent;
